import axios from "axios";

const api = axios.create({
  baseURL: ""
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 处理成功响应中的业务错误码
api.interceptors.response.use(
  (resp) => {
    const data = resp?.data;
    // 如果返回了 code 且不是 0，视为错误
    if (data && data.code !== undefined && data.code !== 0) {
      const error = new Error(data.message || "请求失败");
      error.response = resp;
      error.userMessage = data.message;
      return Promise.reject(error);
    }
    return resp;
  },
  (error) => {
    const data = error?.response?.data;
    const msg = data?.message || data?.detail || error?.message || "请求失败";
    error.userMessage = msg;
    return Promise.reject(error);
  }
);

export default api;

